/*!
 * Copyright 2019 Fondazione Bruno Kessler
 * Licensed under the EUPL, Version 1.1 or - as soon they will be approved by the European
 * Commission - subsequent versions of the EUPL (the "Licence"); You may not use this work
 * except in compliance with the Licence.
 *
 * You may obtain a copy of the Licence at:
 * http://ec.europa.eu/idabc/eupl.html
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the Licence is distributed on an "AS IS" basis, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the Licence for the specific language
 * governing permissions and limitations under the Licence.
 */

import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { CommonState } from "@app/store/common/common.state";
import { Store } from "@ngxs/store";
import { Observable } from "rxjs";
import { filter, map, tap } from "rxjs/operators";

/**
 * Guard that allow to navigate to route only to physician users (ie: users that have access to medical dashboard).
 */
@Injectable({
  providedIn: "root",
})
export class IsPhysicianGuard implements CanActivate {
  constructor(private router: Router, private store: Store) {}

  canActivate(_next: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return this.store.select(CommonState.isPhysician).pipe(
      filter((isPhysician) => isPhysician !== undefined), // Wait until a value has been set (info has been fetched)
      map((isPhysician) => !!isPhysician), // True/false -> navigate / block
      tap((isPhysician) => {
        if (!isPhysician) {
          // Navigate to home
          this.router.navigate(["/"]);
        }
      })
    );
  }
}
